// Cart still uses localStorage (only enrollment goes to backend on checkout)
const CART_KEY = 'edu_cart';
export const getCart = () => { try { return JSON.parse(localStorage.getItem(CART_KEY) || '[]'); } catch { return []; } };
export const setCart = (items) => localStorage.setItem(CART_KEY, JSON.stringify(items));
export const addToCart = (course) => {
  const items = getCart();
  if (items.find(i => i.id === course.id)) return items;
  const next = [...items, course];
  setCart(next);
  return next;
};
export const removeFromCart = (id) => {
  const next = getCart().filter(i => i.id !== id);
  setCart(next);
  return next;
};
export const clearCart = () => setCart([]);
